var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86249 5.6175C6.44249 5.6175 6.11249 5.955 6.11249 6.3675C6.11249 6.78 6.44999 7.1175 6.86249 7.1175C7.27499 7.1175 7.61249 6.78 7.61249 6.3675C7.61249 5.955 7.27499 5.6175 6.86249 5.6175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.095 3.78C15.465 2.3175 14.0775 1.5 12.1425 1.5H5.8575C3.45 1.5 1.5 3.45 1.5 5.8575V12.1425C1.5 14.0775 2.3175 15.465 3.78 16.095C3.9225 16.155 4.0875 16.1175 4.1925 16.0125L16.0125 4.1925C16.125 4.08 16.1625 3.915 16.095 3.78ZM7.8975 9.18C7.605 9.465 7.2225 9.6 6.84 9.6C6.4575 9.6 6.075 9.4575 5.7825 9.18C5.0175 8.46 4.1775 7.3125 4.5 5.9475C4.785 4.71 5.88 4.155 6.84 4.155C7.8 4.155 8.895 4.71 9.18 5.955C9.495 7.3125 8.655 8.46 7.8975 9.18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6025 15.3975C14.7675 15.5625 14.745 15.8325 14.5425 15.945C13.8825 16.3125 13.08 16.5 12.1425 16.5H5.85748C5.63998 16.5 5.54998 16.245 5.69998 16.095L10.23 11.565C10.38 11.415 10.6125 11.415 10.7625 11.565L14.6025 15.3975Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.8575V12.1425C16.5 13.08 16.3125 13.89 15.945 14.5425C15.8325 14.745 15.5625 14.76 15.3975 14.6025L11.5575 10.7625C11.4075 10.6125 11.4075 10.38 11.5575 10.23L16.0875 5.7C16.245 5.55 16.5 5.64 16.5 5.8575Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapActive);
export default __webpack_public_path__ + "static/media/map-active.244a5b94c5da78b85bee7622f65ff568.svg";
export { ForwardRef as ReactComponent };